import { circadiaEngineProvider, localStorageProvider } from "../AppController";

export const isPIN = () => {
  // Check dynamically — on Android the bridge is injected async after module load.
  if (
    circadiaEngineProvider.isWindowCircadia() &&
    localStorageProvider.get("sso") !== "true"
  )
    return false;

  return false;
};
